import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import translationGr from "./locales/fr/translation.json"
import translationENG from "./locales/en/translation.json"

// the translations
const resources = {
  fr: {
    translation: translationGr,
  },

  eng: {
    translation: translationENG,
  },
}

const language = localStorage.getItem("lang")
if (!language) {
  localStorage.setItem("lang", "en")
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("lang") || "en",
    fallbackLng: "en", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
